import { render, staticRenderFns } from "./dossier-progress.vue?vue&type=template&id=53c945c2"
import script from "./dossier-progress.vue?vue&type=script&lang=ts"
export * from "./dossier-progress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports